import { CreditorKey, OccupantKey, SupplierKey, TenantKey, TenantParentKey, UnitKey } from "@feature/pma-entity/pma-entity-types";



export enum PlatformLimitedAccessType {
  SupplierAllCreditor = 0,
  SupplierCreditorList = 1,
  OtherCreditor = 2,

  TenantParentAllTenants = 10,
  TenantParentTenantList = 11,
  SingleTenant = 12,
  Occupant = 13,
  
  Client = 20,
  ClientParent = 21,

  NoLimitedAccess = 100,
}


export interface LimitedAccessConfigModel {
    PlatformLimitedAccessType: PlatformLimitedAccessType;
}

export interface MojoForTenantsLimitedAccessConfigModel extends LimitedAccessConfigModel {
  Tenants: TenantKey[];
  TenantParent: TenantParentKey;
  Occupant: OccupantKey;
}


export interface MojoForSuppliersLimitedAccessConfigModel extends LimitedAccessConfigModel {
  Creditors: CreditorKey[];
  Supplier: SupplierKey;
  Unit: UnitKey;
}

// Add others as required;'
export type LimitedAccessTypes = MojoForTenantsLimitedAccessConfigModel;
